// extracted by mini-css-extract-plugin
export default {"wrapper":"lB-z","viewport":"mB-z","container":"nB-z","slide":"oB-z"};